import { readRemaininghtnrfi4c8vp0 as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_save__qhzefp(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var tmp = readRemaining(_this__u8e3s4.o5g().z5i(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var responseBody = readByteArray(tmp);
  return SavedHttpCall().i5k(_this__u8e3s4.j5g_1, _this__u8e3s4.k5i(), _this__u8e3s4.o5g(), responseBody);
}
function save(_this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_save__qhzefp.bind(VOID, _this__u8e3s4), $completion);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      static i5k(client, request, response, responseBody) {
        var $this = this.j5i(client);
        $this.g5k_1 = responseBody;
        $this.l5g_1 = new (SavedHttpRequest())($this, request);
        $this.m5g_1 = new (SavedHttpResponse())($this, $this.g5k_1, response);
        checkContentLength(contentLength(response), fromInt($this.g5k_1.length), request.s5i());
        $this.h5k_1 = true;
        return $this;
      }
      m5i() {
        return this.h5k_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.j5k_1 = origin;
        this.k5k_1 = call;
      }
      r5i() {
        return this.k5k_1;
      }
      ew() {
        return this.j5k_1.ew();
      }
      s5i() {
        return this.j5k_1.s5i();
      }
      t5i() {
        return this.j5k_1.t5i();
      }
      l5i() {
        return this.j5k_1.l5i();
      }
      t2o() {
        return this.j5k_1.t2o();
      }
      l50() {
        return this.j5k_1.l50();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.l5k_1 = call;
        this.m5k_1 = body;
        this.n5k_1 = origin.a5j();
        this.o5k_1 = origin.b5j();
        this.p5k_1 = origin.c5j();
        this.q5k_1 = origin.d5j();
        this.r5k_1 = origin.l50();
        this.s5k_1 = origin.ew();
      }
      r5i() {
        return this.l5k_1;
      }
      a5j() {
        return this.n5k_1;
      }
      b5j() {
        return this.o5k_1;
      }
      c5j() {
        return this.p5k_1;
      }
      d5j() {
        return this.q5k_1;
      }
      l50() {
        return this.r5k_1;
      }
      ew() {
        return this.s5k_1;
      }
      z5i() {
        return ByteReadChannel(this.m5k_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as save2n0hem2ixzltm,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
